"use strict";

exports.__esModule = true;
exports.SEOModule = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var SEOModule = function SEOModule(props) {
  return React.createElement(React.Fragment, null, React.createElement("title", null, props.title), React.createElement("meta", {
    name: "robots",
    content: props.robots
  }), React.createElement("meta", {
    name: "description",
    content: props.description
  }), React.createElement("meta", {
    property: "og:title",
    content: props.OG_title
  }), React.createElement("meta", {
    property: "og:description",
    content: props.OG_Description
  }), React.createElement("meta", {
    property: "og:type",
    content: props.OG_type
  }), React.createElement("meta", {
    name: "twitter:card",
    content: props.twitter_card
  }), React.createElement("meta", {
    name: "twitter:creator",
    content: props.twitter_creator
  }), React.createElement("meta", {
    name: "twitter:title",
    content: props.twitter_title
  }), React.createElement("meta", {
    name: "twitter:description",
    content: props.twitter_desc
  }), props.children);
};
exports.SEOModule = SEOModule;